import { useState } from "react";





export default function TextArea({
    name, 
    initialValue, 
    placeholder, 
    label, 
    changeCallback,
    className
}){
    const [value, setValue] = useState(initialValue);;

    const handleChange = (e) => {
        setValue(e.target.value);
        changeCallback(e);
    }


    return (
        <>
            <label
                className={`
                    flex
                    flex-col
                    font-semibold
                    text-xl
                    tracking-wider

                    text-body-text-light
                    dark:text-body-text-dark
                    ${
                        className
                    }
                `}
            >
                {label}
                <textarea
                    className="
                        mt-5
                        text-base
                        font-normal
                        tracking-wider

                        text-body-text-light
                        dark:text-body-text-dark

                        px-4
                        py-4
                        border-2
                        border-transparent
                        focus:outline-none
                        focus:border-2
                        focus:border-body-text-light
                        dark:focus:border-body-text-dark
                        transition-colors
                        duration-300
                        ease-in-out
                        rounded
                    "
                    aria-label={label}
                    type="text" 
                    value={value}
                    name={name}
                    placeholder={placeholder}
                    onChange={handleChange}
                />
            </label>
        </>
    );

};